var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 405.333,
    height: 405.333,
    viewBox: "0 0 405.333 405.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 405.333,
    height: 405.333,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M202.422,394.55c106.109,0,192.128-86.019,192.128-192.128S308.531,10.293,202.422,10.293,10.293,96.312,10.293,202.422,96.312,394.55,202.422,394.55Z",
    fill: "none",
    stroke: "#54b329",
    strokeWidth: 21.327
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M202.912,294.565h-.981c-.49-1.96-36.269-62.736-39.21-67.637l-4.411-7.352c-8.822-15.684-20.1-33.328-20.1-51.463A66.157,66.157,0,0,1,149,131.354c2.451-3.431,4.9-5.882,6.862-8.823,1.47-1.96,2.45-1.96,4.411-3.921,3.431-3.431,8.822-6.861,13.723-9.312,22.056-10.783,46.562-8.332,66.167,5.391,1.961,1.471,2.941,2.451,4.411,3.431,1.471,1.961,2.941,2.451,4.411,3.921,7.352,9.313,6.862,7.842,12.254,19.115,2.94,5.882,5.881,17.154,5.881,25.977,0,20.585-10.783,34.8-20.1,51.463-8.822,16.664-21.075,36.759-30.878,52.933C214.185,274.96,203.4,292.605,202.912,294.565ZM122.531,168.113c0,9.312,1.961,17.154,3.921,24.506,6.862,19.6,53.914,94.1,67.637,119.591,4.9,8.332,12.254,8.332,16.665.49l58.325-100.476c14.213-23.526,18.624-51.463,6.861-77.44-6.861-16.174-18.134-28.427-33.328-37.739-23.526-13.723-56.365-14.214-79.4,0-11.763,6.862-21.566,15.194-28.428,27.447-2.94,4.411-2.94,3.921-5.391,9.8C124.982,143.117,122.531,155.37,122.531,168.113Z",
    fill: "#54b329",
    stroke: "#54b329",
    strokeWidth: 0.288,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M202.421,141.646c19.6,0,29.9,24.506,15.194,38.23-8.332,7.352-20.585,7.352-28.427,1.47C172.034,167.133,182.816,141.646,202.421,141.646Zm-37.739,21.566c0,33.818,40.68,51.463,64.206,27.447,25.487-25.487,5.882-64.7-26.467-64.7-15.193,0-27.937,8.822-34.308,22.056C166.642,151.449,164.682,158.31,164.682,163.212Z",
    fill: "#54b329",
    stroke: "#54b329",
    strokeWidth: 0.288,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/location-blue.040310e935106b4543da0ef0f35e637b.svg";
export { ForwardRef as ReactComponent };